/**
 * Sub-category navigation — spec 004 §5, the one line of JS that spec allows.
 *
 * Centres the current category in the rail on load, so a deep item in a 13-item
 * category is not off-screen when the page opens. Scrolls the CONTAINER only:
 * `scrollIntoView` would scroll the page as well.
 *
 * ─────────────────────────────────────────────────────────────────────────────
 * NO LISTENERS OF ANY KIND. Not scroll, not resize, not matchMedia. It runs once
 * and it is done, which is why it needs no rAF throttle and no passive flag
 * (060 contract rule 5 forbids blocks from adding their own scroll listener).
 *
 * This code used to live in `assets/site-header.js` alongside the velocity-gated
 * header retract, so that the block stayed at zero bytes of JS. That retract was
 * withdrawn on 2026-09-03 — the client supplies their own — and `site-header.js`
 * went with it.
 *
 * Registered in `snippets/scripts.liquid` behind `template.name == 'collection'`,
 * NOT from `blocks/collection-subnav.liquid` — a block emitting its own
 * `<script src>` is forbidden (AGENTS.md). The block's tag was inside
 * `{% if subnav.links.size > 0 %}`, so a category with no rail fetched nothing;
 * a template gate cannot read that condition, so every collection page now
 * fetches this file. The guard below is what makes that free: no rail means the
 * query misses and the module exits without touching the DOM.
 *
 * No reduced-motion branch: `scrollLeft` is assigned, not animated, and the rail
 * is `scroll-behavior: auto`. There is no motion to reduce.
 * ─────────────────────────────────────────────────────────────────────────────
 */

const active = document.querySelector('.subnav__link[aria-current="page"]');
const rail = active?.closest('.subnav__rail');

if (active instanceof HTMLElement && rail instanceof HTMLElement) {
  rail.scrollLeft = active.offsetLeft - (rail.clientWidth - active.offsetWidth) / 2;
}
